// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--kXAsq","error":"error--oHCqY","errorMessage":"errorMessage--V2muW"};